export default __webpack_public_path__ + "03efc82880bcfa72566e819d5de1a010.png";